import { useQuery } from '@tanstack/react-query';
import { rSimProductsQueries } from '../utils/rsimProductsQueries';
import { fetchRSimsLastPollingTimestamps } from '../RSimApi/rSimApi';
import { parseResponseDateAndTime } from '@/common/utils/parseResponseDate';
import { useHasFeatureFlag } from 'src/featureFlags/useHasFeatureFlag';

interface TimestampMap {
  [key: string]: string | null;
}

export const useRsimLastPollingTimestamps = ({ euiccs }: { euiccs: string[] }) => {
  const rsimConnectivityMonitoringEnabled = useHasFeatureFlag('RsimConnectivityMonitoringEnabled');

  return useQuery({
    queryKey: rSimProductsQueries.lastPollingTimestamps({ euiccs }),
    queryFn: async () => {
      const lastPollingTimestamps = await fetchRSimsLastPollingTimestamps(euiccs);
      return lastPollingTimestamps;
    },
    select: (timestamps) => {
      const timestampMap = timestamps?.reduce((map, item) => {
        map[item.id] = parseResponseDateAndTime(item.lastPollingTimestamp);
        return map;
      }, {} as TimestampMap);

      return timestampMap;
    },
    enabled: !!euiccs.length && rsimConnectivityMonitoringEnabled,
  });
};
